import {
  enum_,
  type InferOutput,
  number,
  object,
  optional,
  string
} from 'valibot'

import { SITE_IMPORT_JOB_STATUS_TYPE } from '@/libs/api/types'

/**
 * 地点のインポート履歴の検索条件
 */
export const siteImportJobsSearchSchema = object({
  dcId: optional(number()),
  page: optional(number()),
  /** インポートステータス */
  status: optional(enum_(SITE_IMPORT_JOB_STATUS_TYPE)),
  /** ファイル名 */
  fileName: optional(string())
})

export type SiteImportJobsSearch = InferOutput<
  typeof siteImportJobsSearchSchema
>
